import { Button } from '../../components/Buttons'
import Cards from '../../components/Cards'
import InputField from '../../components/InputField'
import { useForm, Controller } from 'react-hook-form'
import { validationConstants } from '../../constants/validations'
import FileInput from '../../components/FileInput'
import { Input, Select } from 'antd'
import { phoneCode, TimeZones } from '../../constants/data'
import { useGetGeneralSettingsQuery, useUpdateGeneralSettingsMutation } from '../../services/settingsSlice'
import Loading from '../../components/Loading'
import { useEffect, useState } from 'react'
import { ClockIcon, MailIcon, UserIcon } from '../../components/Icons/iconImages'
import { toast } from '../../components/Toast/toast'
import { useNavigate } from 'react-router-dom'

function GeneralSettings() {

  const [updateSettings, { isLoading: isUpdateLoading, isSuccess: updateSuccess, isError: updateError, error: updateErrorData }] = useUpdateGeneralSettingsMutation();
  const { data: getUserData } = useGetGeneralSettingsQuery('');
  const navigate = useNavigate();
  console.log("getUserData",getUserData);
  

  const defaultValues = {
    firstName: "",
    lastName: "",
    email: "",
    phoneno: "",
    timeZone: "",
    profile_picture: "",
    file: "",
    countryCode: "+91",
    company_name: "",
    company_website: "",
    company_url: ""
  };

  const {
    getValues,
    setValue,
    handleSubmit,
    control,
    formState: { errors },
    watch
  } = useForm({
    defaultValues,
  });

  // const fileValue = watch('countryCode');

  useEffect(() => {
    if (getUserData?.settings) {
      let values = getUserData?.settings;
      setValue('firstName', values?.first_name)
      setValue('lastName', values?.last_name)
      setValue('email', values?.email)
      setValue('phoneno', values?.phone_no)
      setValue('countryCode', values?.country_code || "+91")
      setValue('timeZone', values?.timezone)
      setValue('profile_picture', values?.profile_picture || "")
      setValue('company_name', values?.company_name || "")
      setValue('company_website', values?.company_website || "")  
      setValue('company_url', values?.company_url || "https://")
    }
  }, [getUserData])

  const handleSave = () => {
    const values: any = getValues();
    const payload = {
      "email": values?.email,
      "first_name": values?.firstName,
      "last_name": values?.lastName,
      "phone_no": values?.phoneno,
      "country_code": values?.countryCode,
      "timezone": values.timeZone,
      "profile_picture": values?.file ?? "",
      "company_name": values?.company_name ?? "",
      "company_website": values?.company_website ?? "",
      "company_url": values?.company_url ?? ""  
    }
    updateSettings(payload);
  }
  console.log("errors", errors);

  useEffect(() => {
    if (updateSuccess) {
      toast.success('Settings updated successfully');
    }
    if (updateError) {
      console.log("error", updateErrorData);
      const errorMessage = updateErrorData && 'data' in updateErrorData ?
        (updateErrorData as any)?.data?.message || 'Failed to update settings' :
        'Failed to update settings';
      toast.error(errorMessage);
    }
  }, [updateSuccess, updateError, updateErrorData]);

  if (isUpdateLoading) {
    return <Loading />;
  }

  return (
    <Cards variant="secondary" classname="p-3 sm:p-4 md:p-6" childClassName="flex-col" title="" bottomButton={undefined}>
      <div className="flex w-full justify-between items-start border-b border-solid border-gray-300 pb-3 sm:pb-4">
        <div>
          <h4 className="text-[#181D27] font-semibold text-base md:text-lg">General</h4>
          <h5 className="font-normal text-[#535862] text-xs md:text-sm">Update your photo and personal details here.</h5>
        </div>
      </div>



      <form onSubmit={handleSubmit(handleSave)} className="">

        <div className="flex w-full justify-between items-start border-b border-solid border-gray-300 pb-3 sm:pb-4 mt-3 sm:mt-4">
          <div>
            <h4 className="text-[#181D27] font-semibold text-sm sm:text-base md:text-lg">Company Details</h4>
          </div>
        </div>

        <div className='grid grid-cols-1 md:grid-cols-2 gap-x-4 sm:gap-x-6 md:gap-x-7 gap-y-3 sm:gap-y-4 pt-3 w-full'>


          {/* Company Name */}
          <InputField
            control={control}
            label="Company Name"
            placeholder="Enter your Company Name"
            type="text"
            name="company_name"
            // rules={{
            //   required: { value: true, message: "Company Name is required" },
            //   ...validationConstants.firstName,
            // }}
            // error={errors.company_name}
          />

          <div>
            <p className="text-xs sm:text-sm text-[#414651] font-medium mb-1 sm:mb-1.5">
             Company URL
            </p>
            <Controller
              control={control}
              name="company_website"
              // rules={{
              //   required: { value: true, message: "Company URL is required" },
              //   ...validationConstants.firstName,
              // }}
              render={({ field, fieldState: { error } }) => (
                <>
                  <div className="flex items-center">
                    <Input
                      {...field}
                      className={`h-10 sm:h-12 mobileInput rounded-full w-full text-sm sm:text-base ${error ? "border-red-500" : "border-gray-300"}`}
                      addonBefore={
                        <Controller
                          control={control}
                          name="company_url"
                          defaultValue="https://"
                          render={({ field: countryField }) => (
                            <Select
                              {...countryField}
                              fieldNames={{ label: "label", value: "value" }}
                              defaultValue="https://"
                              options={[{
                                value: 'https://', label: 'https://'
                              }]}
                              className="w-auto text-xs sm:text-sm"
                              showSearch
                              removeIcon={null}
                              rootClassName="border-gray-300 text-[#535862]"
                            />
                          )}
                        />
                      }
                      placeholder="yourdomain.com"
                      onChange={(value) => field.onChange(value)}
                      style={{ border: error ? "1px solid #F87171" : "" }}
                    />
                  </div>
                  {error && <p className="text-red-400 text-xs sm:text-sm">{error.message}</p>}
                </>
              )}
            />
          </div>


        </div>

        <div className="flex w-full justify-between items-start border-b border-solid border-gray-300 pb-3 sm:pb-4 mt-4 sm:mt-6">
          <div>
            <h4 className="text-[#181D27] font-semibold text-sm sm:text-base md:text-lg">Personal Details</h4>
          </div>
        </div>

        <div className='grid grid-cols-1 md:grid-cols-2 gap-x-4 sm:gap-x-6 md:gap-x-7 gap-y-3 sm:gap-y-4 pt-3 w-full'>


          {/* First Name */}
          <InputField
            control={control}
            label="First Name"
            placeholder="Enter your first name"
            type="text"
            name="firstName"
            rules={{
              required: { value: true, message: "First Name is required" },
              ...validationConstants.firstName,
            }}
            error={errors.firstName}
          />

          {/* Last Name */}
          <InputField
            control={control}
            label="Last Name"
            placeholder="Enter your last name"
            type="text"
            name="lastName"
            rules={{
              required: { value: true, message: "Last Name is required" },
              ...validationConstants.lastName,
            }}
            error={errors.lastName}
          />

          {/* Email Address */}
          <InputField
            control={control}
            label="Email Address"
            placeholder="Enter your email"
            type="email"
            name="email"
            icon={<MailIcon />}
            iconDirection="left"
            rules={{
              required: "Email is required",
              ...validationConstants.email,
            }}
            error={errors.email}
          />

          {/* Phone Number */}
          <div>
            <p className="text-xs sm:text-sm text-[#414651] font-medium mb-1 sm:mb-1.5">
              Phone No<span className="pl-1 text-green-500">*</span>
            </p>
            <Controller
              control={control}
              name="phoneno"
              rules={{
                required: { value: true, message: "Phone No is required" },
                ...validationConstants.phoneno,
              }}
              render={({ field, fieldState: { error } }) => (
                <>
                  <div className="flex items-center">
                    <Input
                      {...field}
                      className={`h-10 sm:h-12 mobileInput rounded-full w-full text-sm sm:text-base ${error ? "border-red-500" : "border-gray-300"}`}
                      addonBefore={
                        <Controller
                          control={control}
                          name="countryCode"
                          defaultValue="+91"
                          render={({ field: countryField }) => (
                            <Select
                              {...countryField}
                              fieldNames={{ label: "label", value: "value" }}
                              defaultValue="+91"
                              options={phoneCode}
                              className="w-auto text-xs sm:text-sm"
                              showSearch
                              removeIcon={null}
                              rootClassName="border-gray-300 text-[#535862]"
                            />
                          )}
                        />
                      }
                      placeholder="Enter your phone no"
                      onChange={(value) => field.onChange(value)}
                      style={{ border: error ? "1px solid #F87171" : "" }}
                    />
                  </div>
                  {error && <p className="text-red-400 text-xs sm:text-sm">{error.message}</p>}
                </>
              )}
            />
          </div>

          {/* Timezone Selection */}
          <div>
            <p className="text-xs sm:text-sm text-[#414651] font-medium mb-1 sm:mb-1.5">
              Timezone<span className="pl-1 text-green-500">*</span>
            </p>
            <Controller
              control={control}
              name="timeZone"
              rules={{
                required: { value: true, message: "Timezone is required" },
              }}
              render={({ field, fieldState: { error } }) => (
                <>
                  <Select
                    {...field}
                    className={`h-10 sm:h-12 rounded-full w-full text-sm sm:text-base ${error ? "border-red-500" : "border-gray-300"}`}
                    options={TimeZones.map((res) => ({ value: res, label: res }))}
                    showSearch
                    prefix={<ClockIcon />}
                    placeholder="Select a timezone"
                    onChange={(value) => field.onChange(value)}
                    style={{ border: error ? "1px solid #F87171" : "" }}
                  />
                  {error && <p className="text-red-400 text-xs sm:text-sm">{error.message}</p>}
                </>
              )}
            />
          </div>

          {/* Profile Picture Upload (Spanning 2 Columns) */}
          <div className="md:col-span-2 flex flex-col sm:flex-row gap-4 sm:gap-5 justify-between border-b border-solid border-gray-300 pb-3 sm:pb-4">
            <div className="flex justify-center sm:justify-start">
              {getUserData?.settings?.profile_picture ? (
                <img src={getUserData?.settings?.profile_picture} alt="Profile" className="w-14 h-14 sm:w-16 sm:h-16 rounded-full object-cover" loading="lazy" />
              ) : (
                <UserIcon className="w-14 h-14 sm:w-16 sm:h-16 p-3 text-gray-500 shadow-sm rounded-full border border-gray-500 bg-white" />
              )}
            </div>
            <div className="flex-1">
              <FileInput
                control={control}
                rules={{
                  required: false,
                  allowedFileTypes: ["SVG", "PNG", "JPG", "GIF"],
                  maxDimensions: { width: 2048, height: 2048 },
                  maxFileSize: 10 * 1024 * 1024,
                }}
              />
            </div>
          </div>
        </div>


        {/* Buttons (Spanning 2 Columns & Right Aligned) */}
        <div className="flex flex-col sm:flex-row justify-end gap-2 sm:gap-3 w-full md:col-span-2 mt-4 sm:mt-6">
          <Button onClick={() => navigate("/dashboard")} className="w-full sm:w-auto order-2 sm:order-1">
            Cancel
          </Button>
          <Button type="primary" onClick={handleSubmit(handleSave)} loading={isUpdateLoading} className="w-full sm:w-auto order-1 sm:order-2">
            Save changes
          </Button>
        </div>
      </form>
    </Cards>

  )
}

export default GeneralSettings